import * as types from '../actionTypes/systemParameter'

let defaultState = {
  systemParameters: [],
  faqUrl: '',
  homePageText: '',
  listOfCandidatesText:'',
  candidateDetailsIntroText:'',
  stateGovtEmployeeLink:'',
  qualificationsHelpText:'',
  skillsExpertiseHelpText:'',
  googleAnalyticsTrackingCode:''
}

const systemParameterReducer = (state = defaultState, action) => {
  if (action.type === types.GET_SYSTEM_PARAMETERS) {
    return {
      ...state,
      systemParameters: action.systemParameters
    }
  } else if (action.type === types.GET_FAQ_URL) {
    return {
      ...state,
      faqUrl: action.faqUrl
    }
  } else if (action.type === types.GET_HOME_PAGE_TEXT) {
    return {
      ...state,
      homePageText: action.homePageText
    }
  } else if (action.type === types.LIST_OF_CANDIDATES_TEXT) {
    return {
      ...state,
      listOfCandidatesText: action.listOfCandidatesText
    }
  } else if (action.type === types.INTRO_TEXT_CANDIDATE_DETAILS) {
    return {
      ...state,
      candidateDetailsIntroText: action.candidateDetailsIntroText
     }
  } else if (action.type === types.STATE_GOVT_EMPLOYEE_LINK) {
    return {
      ...state,
      stateGovtEmployeeLink: action.stateGovtEmployeeLink
     }
  } else if (action.type === types.QUALIFICATIONS_HELPTEXT) {
    return {
      ...state,
      qualificationsHelpText: action.qualificationsHelpText
     }
  } else if (action.type === types.SKILLS_EXPERTISE_HELPTEXT) {
    return {
      ...state,
      skillsExpertiseHelpText: action.skillsExpertiseHelpText
     }
  } else if (action.type === types.CONTACT_US_PAGE_HTMLTEXT) {
    return {
      ...state,
      contactUsPageHtmlText: action.contactUsPageHtmlText
     }

  } else if (action.type === types.DECLARATION_BODY_TEXT) {
    return {
      ...state,
      declarationBodyText: action.declarationBodyText
     }
  } else if (action.type === types.FAQ_FOR_GENERAL_USERS) {
    return {
      ...state,
      faqForGeneralUsersHelpText: action.faqForGeneralUsersHelpText
     }
  } else if (action.type === types.FAQ_FOR_AUTHORISED_USERS) {
    return {
      ...state,
      faqForAuthorisedUsers: action.faqForAuthorisedUsers
     }
  } else if (action.type === types.TITLE_HELPTEXT) {
    return {
      ...state,
      titleHelpText: action.titleHelpText
     }
  } else if (action.type === types.LINKEDIN_LINK_HELPTEXT) {
    return {
      ...state,
      linkedInLinkHelpText: action.linkedInLinkHelpText
     }
  } else if (action.type === types.ANY_COMMENTS_HELPTEXT) {
    return {
      ...state,
      anyCommentsHelpText: action.anyCommentsHelpText
     }

   } else if (action.type === types.COMMUNICATIONS_HELPTEXT) {
    return {
      ...state,
      communicationsHelpText: action.communicationsHelpText
     }

   } else if (action.type === types.GOOGLE_ANALYTICS_TRACKING_CODE) {
    return {
      ...state,
      googleAnalyticsTrackingCode: action.googleAnalyticsTrackingCode
     }

    }else {
    return {
      ...state
    }
  }
}

export default systemParameterReducer



// WEBPACK FOOTER //
// ./src/reducers/systemParameter.js